import { DashboardPanel, IDashboardPanelProps } from '@app/components';
import { useAppSelector } from '@common';
import { DashboardPanelType } from '../entities';
import { selectActiveDashboardPanelKey } from '../store';

export function MainDashboardPanel({ panelKey, ...props }: IProps) {
    const activePanel = useAppSelector(selectActiveDashboardPanelKey);

    return (
        <>
            <DashboardPanel expanded={panelKey === activePanel} {...props} />
        </>
    );
}

interface IProps extends IDashboardPanelProps {
    panelKey: DashboardPanelType;
}
